export default "__VITE_ASSET__Cpy0Rql6__"